import * as React from 'react';
export function defaultRender(children, key) {
    return React.createElement(React.Fragment, { key: key }, children);
}
//# sourceMappingURL=react.js.map